import { IReportsFilesRepository } from "domain/repositories/reports-files-repository";
import { IHttpClient } from "../protocols/http";

export class ReportsFilesDatasource implements IReportsFilesRepository {
  constructor(
    private httpClient: IHttpClient,
    private baseUrl: string = process.env.REACT_APP_API_URL || ""
  ) {}

  async generatePdf(url: string) {
    const encodedUrl = encodeURIComponent(url);

    return this.httpClient
      .request({
        method: "GET",
        baseUrl: this.baseUrl,
        url: "/v1/Insights/generate-pdf",
        params: { url: encodedUrl },
      })
      .then(({ body }) => body.data);
  }
}
